// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomSysOrganizationsParentCompanyLocationSelect from './data'

export default function DataVaxiomSysOrganizationsParentCompanyLocationSelectFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomSysOrganizationsParentCompanyLocationSelect">
      <DataVaxiomSysOrganizationsParentCompanyLocationSelect {...props}>
        {children}
      </DataVaxiomSysOrganizationsParentCompanyLocationSelect>
    </Flow>
  )
}
